import React, { Component } from 'react';
import azLogo from '../assets/autozone_logo.png';
import qsvLogo from '../assets/qsv_logo.png';
import tmsLogo from '../assets/tms_system_logo.png';
import lmsLogo from '../assets/lms_system_logo.png';
import axcelLogo from '../assets/autoexcel_logo.png';

export default class LogoRender extends Component {
    render() {
        return (
            <div>

                {this.props.az_qsv_banner&&
                <div style={{display:'inline-flex', justifyContent:'center',alignItems:'baseline'}}>
                    <img src={azLogo} width='250px' alt={'AutoZone|QSV'} style={{paddingBottom:'5px'}}/>
                    <div style={{borderLeft:'3px solid',borderColor:'#6d6e71', height:'40px',marginLeft:'5px', marginRight:'5px'}}></div>
                    <img src={qsvLogo} height='40px' alt={'QSV'}/>
                </div>}

                {this.props.tms_logo&&
                <div style={{justifyContent:'center',alignItems:'baseline'}}>
                    <img src={tmsLogo} width='250px' alt={'TMS'} style={{paddingBottom:'5px'}}/>
                </div>}
                
                {this.props.lms_logo&&
                <div style={{justifyContent:'center',alignItems:'baseline'}}>
                    <img src={axcelLogo} width='250px' alt={'AutoXcel'} style={{paddingBottom:'5px'}}/><br/>
                    <img src={lmsLogo} width='250px' alt={'LMS'}/>
                </div>}

                {this.props.axl_only&&
                <div style={{justifyContent:'center',alignItems:'baseline'}}>
                    <img src={axcelLogo} width='60px' alt={'AutoXcel'} style={{paddingBottom:'5px'}}/><br/>
                </div>}

            </div>
        );
    }
}